<template>
  <div class="">
    <top-header :type="6" placeholder="卖方资金监管信息录入" hasBorder="true" fontSize="0.32rem" />
    <van-form @submit="onSubmit">
      <van-field
        readonly
        v-model="trusteeBankName"
        name="trusteeBankName"
        label="监管银行"
      />
      <van-field
        readonly
        clickable
        name="info"
        :value="info"
        label="卖方支取人"
        placeholder="请选择卖方支取人"
        @click="showPicker = true"
        :rules="[{ required: true, message: '请选择卖方支取人' }]"
      />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          value-key="t"
          show-toolbar
          :columns="userList"
          @confirm="onConfirm"
          @cancel="showPicker = false"
        />
      </van-popup>
      <van-field
        v-model="withdrawalBankAccountPayee"
        type="number"
        name="withdrawalBankAccountPayee"
        placeholder="请填写卖方银行卡号"
        label="卖方银行卡号"
        :rules="[{ required: true, message: '请填写银行卡号' }]"
      />
      <div class="btn_con m_flex_box flex_hc">
        <van-button size="small" type="info" native-type="submit">
          提交并确认
        </van-button>
        <van-button size="small" plain type="info" native-type="button" @click="$router.go(-1)">
          取消
        </van-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import qs from 'qs'
import topHeader from '@/components/header'
export default {
  data() {
    return {
      userList: [],
      showPicker: false,
      trusteeBankName: '',
      info: '',
      withdrawalBankAccountPayee: '',

    };
  },
  components: {
    topHeader,
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    onSubmit(data) {
      this.$http({
        url: 'cms/contractData/reg/doApprovalOnlineContractSign.do',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        data: {
          id: this.$route.query.approId,
          state: 1,
          sellerIdCard: this.info.split('、')[1],
          sellerName: this.info.split('、')[0],
          withdrawalBankAccountPayee: this.withdrawalBankAccountPayee,
        }
      }).then(res => {
        this.$router.go(-2)
      })
    },
    getDetail() {
      this.$http.post('cms/contractData/reg/getContractSFA.do', qs.stringify({
        contractId: this.$route.query.id
      })).then(res => {
        console.log(res);
        this.trusteeBankName = res.obj.superviseFundAgreementBefore.trusteeBankName;
        const userList = [
            {
              v: res.obj.barPassNo,
              t: res.obj.bargainor + "、" + res.obj.barPassNo,
            },
          ];
          for (var i = 0; i < res.obj.contractTraders.length; i++) {
            if (res.obj.contractTraders[i].traderType == 2) {
              userList.push({
                v: res.obj.contractTraders[i].idNumber,
                t:
                  res.obj.contractTraders[i].traderName +
                  "、" +
                  res.obj.contractTraders[i].idNumber,
              });
            }
          };
          this.userList = userList;
      })
    },
    onConfirm(data) {
      this.info = data.t;
      this.showPicker = false;
    }
  },
};
</script>
<style lang="less" scoped>
.btn_con{
  margin-top: 2rem;
  /deep/
  .van-button{
    margin: 0 0.4rem;
    width: 1.8rem;
  }
}
</style>